import { ref, onBeforeMount } from "vue"
const screenHeight = ref(0)

export function useScreenHeight() {
  function setScreenHeight() {
    const doc = document.documentElement
    doc.style.setProperty("--screen-height", `${window.innerHeight}px`)
    screenHeight.value = window.innerHeight
  }

  onBeforeMount(() => {
    window.addEventListener("resize", setScreenHeight)
    setScreenHeight()
  })

  return { screenHeight }
}
